function SearchParentsFor(start, cls, top) {
  var result;

  var parent = start.parentNode;
  if (parent && parent.getAttribute) {
    var pcls = parent.getAttribute("class");
    if (pcls) {
      var pclsArray = pcls.split(" ");
      for (var i = 0; i < pclsArray.length; i++) {
        if (pclsArray[i] == cls) {
          result = parent;
          break;
        }
      }
    }

    if (!result && (!top || parent != top)) {
      result = SearchParentsFor(parent, cls, top);
    }
  }

  return result;
}

function scrollTop() {
  if ($("body").scrollTop() > 0 || $("html").scrollTop() > 0) {
    $("html, body").animate(
      {
        scrollTop: 0,
      },
      250,
      "swing",
    );
  }
}

function ShowSwatchForm() {
  $(".show-message").removeClass();
  if ($(".filledSwatch").length > 0) {
    var formContainer = document.getElementById("bridgman-select-swatches-form-container");
    var swatchSelectContainer = document.getElementById("bridgman-select-swatches-container");
    var swatchNextButton = document.getElementById("swatch-next-btn");

    formContainer.classList.remove("hidden");
    swatchSelectContainer.classList.add("hidden");
    swatchNextButton.classList.add("hidden");
  } else {
    $(".my-swatches-outer").addClass("show-message");
    setTimeout(function () {
      $(".my-swatches-outer").removeClass("show-message");
    }, 3000);
  }
}

function onSearchBlur() {
  document.querySelector("#manual-address").checked = false;
}

function showXOnSwatch() {
  var selectedSwatches = document.querySelectorAll(".selected-swatch");

  for (var i = 0; i < selectedSwatches.length; i++) {
    var selectedSwatch = selectedSwatches[i];
    if (selectedSwatch.classList.contains("filledSwatch")) {
      var xBtn = selectedSwatch.querySelector(".close-icon");
      xBtn.setAttribute("data-swatch-name", selectedSwatch.dataset.swatchName);
      xBtn.style.display = "block";
    }
  }
}

function removeSwatchFromForm(element) {
  const containerelement = document.querySelector(".bridgman-swatches-render-wrapper");
  var swatchName = element.dataset.swatchName;

  if (!swatchName) {
    var parent = SearchParentsFor(element, "selected-swatch");
    swatchName = parent.dataset.swatchName;
  }

  var selectedSwatches = containerelement.querySelectorAll(".single-swatch[data-swatch-name='" + swatchName + "']");

  for (var i = 0; i < selectedSwatches.length; i++) {
    selectedSwatches[i].click();
  }
  element.removeAttribute("data-swatch-name");
}

function HandleSwatchSuccess(e) {
  var section = document.querySelector(".bridgman-swatches");
  var redirect = section.dataset.redirect;
  var swatch_type = section.dataset.swatch_type;
  if (redirect) {
    window.location.href = redirect;
  } else {
    if (swatch_type == "swatch_type_outdoor") {
      window.location.href = window.location.origin + "/pages/thank-you?type=swatch-request";
    } else if (swatch_type == "fabric-swatch") {
      window.location.href = window.location.origin + "/pages/thank-you-indoor-sofa?type=" + swatch_type;
    } else {
      window.location.href = window.location.origin + "/pages/thank-you?type=swatch-request";
    }
  }
}

function SwatchSendToKlaviyo(param) {
  function TryNow() {
    if (window._learnq) {
      window._learnq.push(param);
      var form = document.getElementById("bridgman-select-swatches-form-container");
      var swatchesTop = document.querySelector(".my-swatches");
      var success = document.getElementById("bridgman-select-swatched-success");
      HandleSwatchSuccess();
    } else {
      setTimeout(TryNow, 500);
    }
  }
  TryNow();
}

function setTelInputFilter(textbox, inputFilter) {
  // var inputArray = [ ...textbox ];
  // Convert HTML Collection to an array:
  var inputArray = Array.prototype.slice.call(textbox);
  var eventArray = ["input", "keydown", "keyup", "mousedown", "mouseup", "select", "contextmenu", "drop"];

  for (var i = 0; i < eventArray.length; i++) {
    var event = eventArray[i];
    for (var j = 0; j < inputArray.length; j++) {
      var input = inputArray[j];
      input.addEventListener(event, function () {
        if (inputFilter(this.value)) {
          this.oldValue = this.value;
          this.oldSelectionStart = this.selectionStart;
          this.oldSelectionEnd = this.selectionEnd;
        } else if (this.hasOwnProperty("oldValue")) {
          this.value = this.oldValue;
          this.setSelectionRange(this.oldSelectionStart, this.oldSelectionEnd);
        } else {
          this.value = "";
        }
      });
    }
  }
}

window.addEventListener("DOMContentLoaded", function (e) {
  setTelInputFilter(document.querySelectorAll(".number-input"), function (value) {
    return /^\d*\.?\d*$/.test(value); // Allow digits and '.' only, using a RegExp
  });

  showXOnSwatch();

  $("#requestSwatches").submit(function (e) {
    // spam prevention hack
    const honeypot = document.querySelector("#requestSwatches input#company");
    if (honeypot && honeypot.value !== "") return;

    e.preventDefault();
    e.stopImmediatePropagation(); // This is to prevent the .submit firing twice

    let productType = "outdoor";

    if ($("#requestSwatches").hasClass("outdoor")) {
      hj("event", "outdoor_swatch_request");
    } else if ($("#requestSwatches").hasClass("indoor")) {
      productType = "indoor";
      hj("event", "indoor_swatch_request");
    }
    var form = e.currentTarget;
    var _learnq = _learnq || [];
    var swatches = [];
    $(".selected-swatches-wrapper .filledSwatch").each(function (index) {
      swatches[index] = $(this).data("swatch-name");
    });
    swatches = Object.assign({}, swatches);

    var email = $("#email").val();
    var accepts_marketing = form.querySelector("input[ name='data-capture' ]").checked;
    var have_you_heard_of_bridgman_before = "No";

    var selectedRadio = form.querySelector('input[name="have_you_heard_of_bridgman_before"]:checked');

    if (selectedRadio !== null) {
      have_you_heard_of_bridgman_before = selectedRadio.value;
    }

    var Where_did_you_hear_about_us = form.querySelector('[name="where_did_you_hear_about_us"]').value;
    if (Where_did_you_hear_about_us == "Other") {
      Where_did_you_hear_about_us = form.querySelector('[name="catalogue_Where_did_you_hear_about_us_other"]').value;
    }

    var requestSwatches = {
      $first_name: $("#first_name").val(),
      $last_name: $("#last_name").val(),
      $Zip: $("#post_code").val(),
      $email: email,
      $address1: $("#address_line_1").val(),
      $address2: $("#address_line_2").val(),
      $city: $("#city").val(),
      $country: $("#country").val(),
      $phone_number: $("#phone").val(),
      $source: Where_did_you_hear_about_us,
      swatches: swatches,
      $have_you_heard_of_bridgman_before: have_you_heard_of_bridgman_before,
    };

    if (accepts_marketing && accepts_marketing == true) {
      requestSwatches.$accepts_marketing = accepts_marketing;
    }

    requestSwatches["producttype"] = productType;

    if (requestSwatches.$accepts_marketing) {
      var properties = {
        $email: email,
        Catalogue_Type: "",
        Catalogue_Name: "",
        $source: requestSwatches.$source,
        Response_Type: "",
        $accepts_marketing: requestSwatches.$accepts_marketing,
      };
    } else {
      var properties = {
        $email: email,
        Catalogue_Type: "",
        Catalogue_Name: "",
        $source: requestSwatches.$source,
        Response_Type: "",
      };
    }
    let mergedProperties = properties;
    let mergedSwatches = requestSwatches;
    const utmProperties = utmParams();
    if (utmProperties) {
      mergedProperties = { ...properties, ...utmProperties };
      mergedSwatches = { ...requestSwatches, ...utmProperties };
    }
    var trackProperties = {
      event: "Request Swatches",
      trackData: mergedSwatches,
    };
    KlaviyoTrackV2(mergedProperties, trackProperties, function () {
      if (productType && productType == "indoor") {
        jQuery.post("https://hooks.zapier.com/hooks/catch/9220888/b67nvhe/silent/", mergedSwatches).then(function () {
          HandleSwatchSuccess();
        });
      } else {
        jQuery.post("https://hooks.zapier.com/hooks/catch/9220888/o0nnojs/silent/", mergedSwatches).then(function () {
          HandleSwatchSuccess();
        });
      }
    });
  });
});
